import { render, staticRenderFns } from "./sblxIndex.vue?vue&type=template&id=12b58ae4&"
import script from "./sblxIndex.vue?vue&type=script&lang=js&"
export * from "./sblxIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports